import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import ReactHTMLElement from "react-html-element";
import App from "./App";
import "./index.css";
import './Asset/Awl-min/awl.min.js';

// ReactDOM.render(<App />, document.getElementById('root'));


const root = document.getElementById('root');
const rootElement = createRoot(root);

rootElement.render(<App />);

// class CustomWidgetCustomElement extends ReactHTMLElement {
//   connectedCallback() {
//     const mountPoint = document.createElement("div");
//     this.appendChild(mountPoint);
//     ReactDOM.render(<App />, this);
//   }
// }

// customElements.define("custom-widget-cms", CustomWidgetCustomElement);

// class CustomWidgetCustomElement extends ReactHTMLElement {
//     connectedCallback() {
//       const mountPoint = document.createElement("div");
//       this.appendChild(mountPoint);
  
//       const root = createRoot(mountPoint);
//       root.render(<App />);
//     }
//   }
  
//   customElements.define("custom-widget-cms", CustomWidgetCustomElement);
